module.exports = __webpack_public_path__ + "static/media/horizontal_blured_keyboard.706e0e9a.png";